import { render } from "./ProjectCommentsStreams.vue?vue&type=template&id=cc6861d2"
import script from "./ProjectCommentsStreams.vue?vue&type=script&lang=js"
export * from "./ProjectCommentsStreams.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__